//
//
//
//

/* eslint-disable camelcase */
import LoadingOverlay from '~/components/common/LoadingOverlay.vue';
import { generateMetaHead } from '~/utils/meta';
export default {
  components: {
    LoadingOverlay
  },
  layout: 'empty',

  head() {
    return { ...generateMetaHead({
        title: 'Members Area Card Login | Extra',
        description: 'Already signed up with Extra? Login to our Members Area for everything you need to get your Extra Card set up.'
      })
    };
  },

  mounted() {
    this.$router.replace('/members/card');
  },

  methods: {}
};